import { I18n, Language } from "../types";
import en from "./en";

export const translate = (language: Language): I18n =>
  ({
    [Language.English]: en,
  }[language]);
